import { EventPayload } from '@/services/amplitude/interfaces/event-payload.interface'
import EventContext from '@/services/amplitude/interfaces/event-context.interface'
import LanguageSkill from '@/services/amplitude/interfaces/language-skill.interface'
import { LanguageLevelMapper } from '@/mappers/LanguageLevelMapper'

class EventPayloadFactory {
  private mapping = {
    universityEntranceQualification: (context: EventContext): EventPayload => {
      return {
        eventType: 'onboarding_hzb_saved',
        eventProperties: {
          hzb_type: this.getUniversityEntranceQualification(context),
        },
      }
    },
    universityEntranceQualificationBw: (
      context: EventContext,
    ): EventPayload => {
      return {
        eventType: 'onboarding_hzbBw_saved',
        eventProperties: {
          hzb_bw: this.getUniversityEntranceQualificationBw(context),
        },
      }
    },
  }

  public buildPayload(key: string, context: unknown): EventPayload | null {
    const mapper = this.mapping[key as keyof typeof this.mapping]
    if (mapper) {
      return mapper(context as EventContext)
    }

    return null
  }

  private getGermanLanguageLevel(context: EventContext): string | null {
    const germanLevel =
      context.languageSkills?.filter(
        (lang: LanguageSkill) => lang.code === 'de',
      )[0]?.level || null

    if (germanLevel) {
      return LanguageLevelMapper.mapLevel(germanLevel)
    }

    return null
  }

  private getUniversityEntranceQualification(
    context: EventContext,
  ): string | null {
    return context.universityEntranceQualification || null
  }

  private getUniversityEntranceQualificationBw(
    context: EventContext,
  ): boolean | null {
    return context.universityEntranceQualificationBw ?? null
  }
}

export default new EventPayloadFactory()
